import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'

import { firestore } from '@/firebase.js'
import { CLUBLINKS_LIMIT } from '@/constants.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoadingClublinks: false,
    clublinks: [],
    isSigningIn: false,
    isSigningOut: false,
    isConnected: false
  },
  mutations: {
    loadClublink (state, { isLoading }) {
      state.isLoadingClublinks = isLoading
    },
    signIn (state, isSigningIn) {
      state.isSigningIn = isSigningIn
    },
    signOut (state, isSigningOut) {
      state.isSigningOut = isSigningOut
    },
    isConnected (state, isConnected) {
      state.isConnected = isConnected
    },
    ...vuexfireMutations
  },
  actions: {
    bindClublinks: firestoreAction(async ({ bindFirestoreRef, commit }, { userId }) => {
      commit('loadClublink', { isLoading: true })
      await bindFirestoreRef('clublinks', firestore.collection('clublinks')
        .where('owner', '==', userId)
        .orderBy('name')
        .limit(CLUBLINKS_LIMIT))
      commit('loadClublink', { isLoading: false })
    }),
    unbindClublinks: firestoreAction(({ unbindFirestoreRef }) => {
      unbindFirestoreRef('clublinks')
    })
  }
})
